module.exports = __webpack_public_path__ + "static/media/6.8c6e6973.jpg";